import { InventoryTypePlaceholderPage } from "../inventory-placeholder";

export const MuscleFleshPage = () => {
  return <InventoryTypePlaceholderPage title="Muscle Flesh" />;
};
